


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master accessProfile] Init';
export const DESTROY_SCREEN = '[Master accessProfile] Destroy';

export const INIT_STATE = '[Master accessProfile] Init State';
export const INIT_VALUE = '[Master accessProfile] Init Value';
export const INIT_VALUE_SUCCESS = '[Master accessProfile] Init Value Success';
export const INIT_VALUE_FAIL = '[Master accessProfile] Init Value Fail';
export const FETCH_FIELD_POSSIBLE_VALUES =
  '[Master access-profile] Fetch Field Possible Values';
export const FETCH_FIELD_POSSIBLE_VALUES_SUCCESS =
  '[Master access-profile] Fetch Field Possible Values Success';
export const FETCH_FIELD_POSSIBLE_VALUES_FAIL =
  '[Master access-profile] Fetch Field Possible Values Fail';

export const UPDATE_DATA = "[Master accessProfile] Update Data";


    export const ANTERIOR = '[Master accessProfile] Anterior';
export const ANTERIOR_SUCCESS = '[Master accessProfile] Anterior Success';
export const ANTERIOR_FAIL = '[Master accessProfile] Anterior Fail';


    export const PROXIMO = '[Master accessProfile] Proximo';
export const PROXIMO_SUCCESS = '[Master accessProfile] Proximo Success';
export const PROXIMO_FAIL = '[Master accessProfile] Proximo Fail';




export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);

  // Anterior action
export const anteriorAction = ngrxCreateAction(ANTERIOR,payload => payload);

export const anteriorSuccessAction = ngrxCreateAction(ANTERIOR_SUCCESS,payload => payload);

export const anteriorFailAction = ngrxCreateAction(ANTERIOR_FAIL, payload => payload);
  // Proximo action
export const proximoAction = ngrxCreateAction(PROXIMO,payload => payload);

export const proximoSuccessAction = ngrxCreateAction(PROXIMO_SUCCESS,payload => payload);

export const proximoFailAction = ngrxCreateAction(PROXIMO_FAIL, payload => payload);



        

export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);
export const fetchFieldPossibleValuesAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES,payload => payload);
export const fetchFieldPossibleValuesSuccessAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_SUCCESS,payload => payload);
export const fetchFieldPossibleValuesFailAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_FAIL,payload => payload);


                            


export const updateDataAction = ngrxCreateAction(
  UPDATE_DATA,
  payload => payload
);

